module.exports = __webpack_public_path__ + "media/images/facebook_48-f907784683c9efb4fbccf5665463d87b.png";